import styled from 'styled-components';
import { useCallback } from 'react';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';

import { config } from '_config';
import { theme } from '_constants/theme';
import { ROUTES } from '_constants/routes';
import { createQueryString } from '_helpers/urls';

import { selectFormValues as selectFilingFormValues } from '_redux/order/selector';

import * as Layout from '_components/atomic/layouts';

const StyledContainer = styled.div`
  padding-top: ${theme.spaces.large}px;
  margin-bottom: ${theme.spaces.large6X}px;
  position: relative;

  @media ${theme.devices.tablet} {
    min-height: 120px;
    padding-top: ${theme.spaces.small2X}px;
    margin-bottom: ${theme.spaces.large}px;
  }
`;

const StyledImageContainer = styled.div`
  min-height: 120px;
  background: ${theme.colors.indigo[600]};
  border-radius: 24px;

  img {
    width: 100%;
  }
`;

const StyledContentBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 24px;
  bottom: 0;
  left: 0;
  right: 0;

  @media ${theme.devices.tablet} {
    top: 4px;
  }
`;

const StyledLink = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spaces.regular}px;
  padding-top: ${theme.spaces.small2X}px;
  padding-bottom: ${theme.spaces.small2X}px;
  padding-left: ${theme.spaces.large}px;
  padding-right: ${theme.spaces.large}px;
  border: 2px solid ${theme.colors.white};
  border-radius: 10px;
  cursor: pointer;
`;

const StyledIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  picture {
    display: flex;
    align-items: center;
  }
`;

const JoinBanner = () => {
  const router = useRouter();
  const filingFormValues = useSelector(selectFilingFormValues);

  const handleStart = useCallback(() => {
    router.push(
      `${ROUTES.llcIncorporationFiling}${createQueryString({
        step: filingFormValues?.step || 0,
      })}`,
      undefined,
      { shallow: true }
    );
  }, [router, filingFormValues]);

  return (
    <StyledContainer>
      <StyledImageContainer>
        <StyledImageContainer>
          <picture>
            <source
              srcSet={`${config.basePath}/images/blog-lines-and-logo-pattern.svg`}
              type="image/svg+xml"
            />
            <img
              src={`${config.basePath}/images/blog-lines-and-logo-pattern.svg`}
              alt=""
            />
          </picture>
        </StyledImageContainer>
        <StyledContentBox>
          <Layout.Card.Text
            size={theme.fontSizes.large4X}
            color={theme.colors.white}
            boldest
            centered
          >
            Join Millions of LLC’s Formed Each Year
          </Layout.Card.Text>
          <StyledLink onClick={handleStart}>
            <Layout.Card.Text
              size={theme.fontSizes.medium}
              color={theme.colors.white}
              boldest
              centered
              noBottomSpace
            >
              START BUSINESS
            </Layout.Card.Text>
            <StyledIconContainer>
              <picture>
                <source
                  srcSet={`${config.basePath}/images/blog-left-arrow.svg`}
                  type="image/svg+xml"
                />
                <img
                  src={`${config.basePath}/images/blog-left-arrow.svg`}
                  alt=""
                />
              </picture>
            </StyledIconContainer>
          </StyledLink>
        </StyledContentBox>
      </StyledImageContainer>
    </StyledContainer>
  );
};

export default JoinBanner;
